'use strict';
import * as angular from 'angular';

export class AngularModule {
	static Create(id: string, requires: string[]): angular.IModule {
		return angular.module(id, requires);
	}
}